export default class DARefreshTokenModel {
    constructor(
        id_refresh_token
    ) {
        this.id_refresh_token = id_refresh_token ? id_refresh_token : ''
    }
}